<template>
  <div class="app">
    <div class="app-body">
      <Sidebar />
      <div class="app-content">
        <Navbar />
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Sidebar from '@/components/Sidebar.vue'
export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar
  }
}
</script>
